// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary-gradient: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  --secondary-gradient: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  --sidebar-gradient: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  --primary-color: #667eea;
  --secondary-color: #764ba2;
  --text-primary: #303133;
  --text-secondary: #5a6c7d;
  --text-light: #909399;
  --border-light: rgba(102, 126, 234, 0.1);
  --shadow-light: 0 2px 8px rgba(0, 0, 0, 0.05);
  --shadow-medium: 0 4px 16px rgba(0, 0, 0, 0.1);
  --shadow-heavy: 0 8px 32px rgba(0, 0, 0, 0.15);
  --border-radius: 8px;
  --border-radius-large: 12px;
  --transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
html,
body {
  height: 100%;
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', '微软雅黑', Arial, sans-serif;
  font-size: 14px;
  line-height: 1.6;
  color: var(--text-primary);
  background: var(--secondary-gradient);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
#app {
  height: 100%;
}
.layout-container {
  height: 100vh;
  display: flex;
  flex-direction: column;
}
.layout-header {
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 1000;
}
.layout-body {
  flex: 1;
  display: flex;
  overflow: hidden;
}
.layout-sidebar {
  width: 200px;
  background: #fff;
  border-right: 1px solid #e6e6e6;
  transition: width 0.3s;
}
.layout-sidebar.collapsed {
  width: 64px;
}
.layout-content {
  flex: 1;
  padding: 20px;
  overflow-y: auto;
  background: #f5f5f5;
}
@media (max-width: 768px) {
  .layout-sidebar {
    position: fixed;
    left: -200px;
    top: 60px;
    height: calc(100vh - 60px);
    z-index: 999;
    transition: left 0.3s;
  }
  .layout-sidebar.mobile-show {
    left: 0;
  }
  .layout-content {
    padding: 15px;
  }
}
.content-card {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  padding: 24px;
  margin-bottom: 20px;
}
.content-card .card-title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 16px;
  border-bottom: 2px solid #409eff;
  padding-bottom: 8px;
}
.content-card .card-content {
  color: #606266;
  line-height: 1.6;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/global.less"],"names":[],"mappings":"AACA;EACE,qEAAA;EACA,uEAAA;EACA,qEAAA;EACA,wBAAA;EACA,0BAAA;EACA,uBAAA;EACA,yBAAA;EACA,qBAAA;EACA,wCAAA;EACA,6CAAA;EACA,8CAAA;EACA,8CAAA;EACA,oBAAA;EACA,2BAAA;EACA,mDAAA;AAAF;AAIA;EACE,SAAA;EACA,UAAA;EACA,sBAAA;AAFF;AAKA;;EAEE,YAAA;EACA,yHAAA;EAGA,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,qCAAA;EACA,mCAAA;EACA,kCAAA;AALF;AAQA;EACE,YAAA;AANF;AAUA;EACE,aAAA;EACA,aAAA;EACA,sBAAA;AARF;AAWA;EACE,gBAAA;EACA,wCAAA;EACA,aAAA;AATF;AAYA;EACE,OAAA;EACA,aAAA;EACA,gBAAA;AAVF;AAaA;EACE,YAAA;EACA,gBAAA;EACA,+BAAA;EACA,sBAAA;AAXF;AAaE;EACE,WAAA;AAXJ;AAeA;EACE,OAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;AAbF;AAiBA;EACE;IACE,eAAA;IACA,YAAA;IACA,SAAA;IACA,0BAAA;IACA,YAAA;IACA,qBAAA;EAfF;EAiBE;IACE,OAAA;EAfJ;EAmBA;IACE,aAAA;EAjBF;AACF;AAqBA;EACE,gBAAA;EACA,kBAAA;EACA,yCAAA;EACA,aAAA;EACA,mBAAA;AAnBF;AAcA;EAQI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gCAAA;EACA,mBAAA;AAnBJ;AAMA;EAiBI,cAAA;EACA,gBAAA;AApBJ;AAyBA;;EAEE,wBAAA;AAvBF;AA0BA;;EAEE,UAAA;AAxBF;AA2BA;EACE,yBAAA;AAzBF;AA4BA;EACE,iDAAA;AA1BF;AA6BA;;EAEE,2BAAA;EACA,UAAA;AA3BF","sourcesContent":["// 颜色变量\n:root {\n  --primary-gradient: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  --secondary-gradient: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);\n  --sidebar-gradient: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);\n  --primary-color: #667eea;\n  --secondary-color: #764ba2;\n  --text-primary: #303133;\n  --text-secondary: #5a6c7d;\n  --text-light: #909399;\n  --border-light: rgba(102, 126, 234, 0.1);\n  --shadow-light: 0 2px 8px rgba(0, 0, 0, 0.05);\n  --shadow-medium: 0 4px 16px rgba(0, 0, 0, 0.1);\n  --shadow-heavy: 0 8px 32px rgba(0, 0, 0, 0.15);\n  --border-radius: 8px;\n  --border-radius-large: 12px;\n  --transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n// 全局样式重置\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nhtml,\nbody {\n  height: 100%;\n  font-family:\n    'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB',\n    'Microsoft YaHei', '微软雅黑', Arial, sans-serif;\n  font-size: 14px;\n  line-height: 1.6;\n  color: var(--text-primary);\n  background: var(--secondary-gradient);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n#app {\n  height: 100%;\n}\n\n// 布局样式\n.layout-container {\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.layout-header {\n  background: #fff;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  z-index: 1000;\n}\n\n.layout-body {\n  flex: 1;\n  display: flex;\n  overflow: hidden;\n}\n\n.layout-sidebar {\n  width: 200px;\n  background: #fff;\n  border-right: 1px solid #e6e6e6;\n  transition: width 0.3s;\n\n  &.collapsed {\n    width: 64px;\n  }\n}\n\n.layout-content {\n  flex: 1;\n  padding: 20px;\n  overflow-y: auto;\n  background: #f5f5f5;\n}\n\n// 响应式设计\n@media (max-width: 768px) {\n  .layout-sidebar {\n    position: fixed;\n    left: -200px;\n    top: 60px;\n    height: calc(100vh - 60px);\n    z-index: 999;\n    transition: left 0.3s;\n\n    &.mobile-show {\n      left: 0;\n    }\n  }\n\n  .layout-content {\n    padding: 15px;\n  }\n}\n\n// 卡片样式\n.content-card {\n  background: #fff;\n  border-radius: 8px;\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);\n  padding: 24px;\n  margin-bottom: 20px;\n\n  .card-title {\n    font-size: 18px;\n    font-weight: 600;\n    color: #303133;\n    margin-bottom: 16px;\n    border-bottom: 2px solid #409eff;\n    padding-bottom: 8px;\n  }\n\n  .card-content {\n    color: #606266;\n    line-height: 1.6;\n  }\n}\n\n// 动画效果\n.fade-enter-active,\n.fade-leave-active {\n  transition: opacity 0.3s;\n}\n\n.fade-enter,\n.fade-leave-to {\n  opacity: 0;\n}\n\n.slide-fade-enter-active {\n  transition: all 0.3s ease;\n}\n\n.slide-fade-leave-active {\n  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);\n}\n\n.slide-fade-enter,\n.slide-fade-leave-to {\n  transform: translateX(10px);\n  opacity: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
